import React from 'react';
import InstrumentPanel from 'ff/debrief/layouts/InstrumentPanel';
import InstrumentAccordion from 'ff/debrief/components/instruments/InstrumentAccordion';
import InstrumentCluster from 'ff/debrief/components/instruments/InstrumentCluster';
import { useChrono, useCurrentDebrief } from 'ff/debrief/hooks';

const Instruments = () => {
    const { currentPoint } = useChrono();
    const { hasDebrief } = useCurrentDebrief();
    if (!hasDebrief) return null;

    const formatValue = (num: number | null, dec = 0, pad = false) => {
        if (num == null) return '--';
        const rnd = dec ? parseFloat(num.toFixed(dec)) : Math.round(num);
        const formatted = (Object.is(rnd, -0) ? 0 : rnd).toLocaleString();
        return pad ? formatted.padStart(3, '0') : formatted;
    };

    const speedValues = [
        `${formatValue(currentPoint?.indicatedAirSpeed)} kts IAS`,
        `${formatValue(currentPoint?.trueAirSpeed)} TAS`,
        `${formatValue(currentPoint?.groundSpeed)} GS`,
    ];

    const altitudeValues = [
        `${formatValue(currentPoint?.verticalSpeed)} fpm`,
        `${formatValue(currentPoint?.aboveGroundLevel)}' AGL`,
        `${formatValue(currentPoint?.altitudeFeet)}' MSL`,
    ];

    const attitudeValues = [
        `${formatValue(currentPoint?.bankDeg)}° bank`,
        `${formatValue(currentPoint?.magneticHeading, 0, true)}° HDG`,
        `${formatValue(currentPoint?.magneticCourse, 0, true)}° Track`,
        `${formatValue(currentPoint?.turnRate, 1)}° Per Sec`,
    ];

    const windValues = [
        `${formatValue(currentPoint?.windVelocity)} kt wind`,
        `${formatValue(currentPoint?.windDirection, 0, true)}°`,
        `${formatValue(currentPoint?.headwind)} kt Head`,
        `${formatValue(currentPoint?.crosswind)} kt Cross`,
    ];

    return (
        <InstrumentPanel>
            <InstrumentAccordion>
                <InstrumentCluster values={speedValues} />
                <InstrumentCluster values={altitudeValues} />
                <InstrumentCluster values={attitudeValues} />
                <InstrumentCluster values={windValues} />
            </InstrumentAccordion>
        </InstrumentPanel>
    );
};
export default Instruments;
